import * as React from "react";
import "./styles/effects.css";
import { Menu, Templates, Form } from "./pages";


export class Marketing extends React.Component {
  render() {
    return this.renderContent();
  }

  renderContent() {
    switch (this.props.location.pathname) {
      case "/marketing/listing":
        return (
          <Templates route={this.props.location.pathname}/>
        );
      case "/marketing":
        return (
          <Menu />
        );
      default:
        return (
          <Form route={this.props.location.pathname}/>
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/marketing/index.js